class WindowMoveLocker {
    isBlocked = false
    constructor() {
        window.addEventListener(
            'touchmove',
            (event) => {
                // We let the event go through as normal as nothing
                // is blocking the touchmove
                if (!this.isBlocking) {
                    return;
                }

                // Our event handler would have worked correctly if the browser
                // was not webkit based, or an older version of webkit.
                if (event.defaultPrevented) {
                    return;
                }

                // Okay, now we need to step in and fix things
                event.preventDefault();

                // Forcing this to be non-passive so we can get every touchmove
                // Not activating in the capture phase like the dynamic touchmove we add.
                // Technically it would not matter if we did this in the capture phase
            }, {
                passive: false,
                capture: false
            },
        );
    }

    preventTouchMove = () => {
        this.isBlocked = true;
    }

    releaseTouchMove = () => {
        this.isBlocked = false;
    }
}

export default new WindowMoveLocker();
